export const BRAND_INFO = {
  name: 'Label by Swathy Reddy',
  domain: 'labelbyswathyreddy.com',
  logo: 'https://res.cloudinary.com/dqcxekzxn/image/upload/v1768493188/WhatsApp_Image_2026-01-15_at_1_LE_upscale_ultra_size_of_changes_0_intensity_10_ncaydq.jpg',
  founder: {
    name: 'Swathy Reddy',
    image: 'https://res.cloudinary.com/dqcxekzxn/image/upload/v1768050059/WhatsApp_Image_2026-01-07_at_10.49.55_PM_rj5nst.jpg',
    email: 'Swathyreddy169@icloud.com'
  },
  address: {
    line1: 'Flats no 301&302, Sri Sai eDurga castle',
    line2: 'Naveen nagar colony, Road no 1 Banjarahills',
    city: 'Hyderabad',
    state: 'Telangana',
    postalCode: '500034',
    country: 'India'
  },
  contact: {
    whatsapp: '9000360756',
    phone: '7569060926',
    email: 'Swathyreddy169@icloud.com'
  },
  social: {
    instagram: 'https://www.instagram.com/label_swathyreddy?igsh=Z2tkYXVrYmpjNDRy&utm_source=qr'
  },
  story: `Rooted in the vibrant culture of Hyderabad, Swathy Reddy is a designer-led saree brand born from creativity, passion, and a deep respect for Indian craftsmanship.

Founded 8 years ago by designer Swathy Reddy, the brand began with a simple yet powerful vision—to create sarees that blend timeless tradition with modern design sensibilities. With a trained eye for detail and aesthetics, Swathy personally designs and curates every piece, ensuring each saree carries her signature of elegance and originality.

For her, a saree is more than fabric—it is a canvas. A canvas where heritage weaves meet contemporary silhouettes, where rich textures, colours, and patterns come together to tell a story of grace and individuality.

At Swathy Reddy, every creation reflects thoughtful design, premium fabrics, and meticulous craftsmanship. From bespoke bridal drapes to elegant festive and everyday wear, our sarees are designed to make women feel confident, empowered, and timelessly beautiful.

After eight fulfilling years, the brand continues to evolve—guided by creativity, inspired by tradition, and driven by a commitment to quality and authenticity.

Welcome to Swathy Reddy — designer sarees crafted with heart, heritage, and style.`
};

export const FREE_SHIPPING_THRESHOLD = 5000;
export const SHIPPING_COST = 200;

export const CATEGORIES = ['Silk', 'Banarasi', 'Designer', 'Bridal', 'Party'];
export const COLLECTIONS = ['Silk', 'Banarasi', 'Designer', 'Bridal', 'Celebrate'];